import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const SentenceElementSubjekt = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 14),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeMiterlimit: 1.5,
    strokeWidth: "8",
    children: [/*#__PURE__*/jsx("path", {
      d: "M48.967 95.458V4.497",
      transform: "rotate(45 56.76 47.188) scale(1.10215 1.07962)"
    }), /*#__PURE__*/jsx("path", {
      d: "M48.967 95.458V4.497",
      transform: "rotate(135 30.454 -2.8) scale(1.10215 -1.07962)"
    })]
  });
};

export { SentenceElementSubjekt };
//# sourceMappingURL=sentence-element.subjekt.js.map
